<p>Retailer dashboard works!</p>
